module.exports = __webpack_public_path__ + "img/logo.405e69f5.jpg";